/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function PatientName({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Standard/Gallery/Content/PatientName"
  
}) {
let patientPersonValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person',
format: fromFormat.patientName,
})
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h1"
 data="patient.person"
 format="/Data/format.js patientName"
 text={patientPersonValueData}
/>
{children}
</React.Fragment>)
}